import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useProjectSupportGuide, useFind: useProjectSupportGuides } = getCRUDHooks({
  entityName: 'projectSupportGuides',
  get: ({ projectId, sectionId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.id(projectId)
      .supportGuides.get(sectionId),
  find: ({ projectId }) =>
    clientApi.getOCClient().helpers.learningContent.projects.id(projectId).supportGuides.find(),
});

export { useProjectSupportGuide, useProjectSupportGuides };
